import { Button, Divider, Text } from '$components'
import { Popover, PopoverContent, PopoverTrigger } from '@radix-ui/react-popover'
import { Filter } from './types'
import { Fragment } from 'react'
import { motion } from 'framer-motion'
import { useFilters } from './hooks/use-filters'
import { FilterItem } from './filter-item'
import { FilterIcon } from '$components'

export type DesktopFiltersProps = {
  filters: Filter[]
}

export function DesktopFilters({ filters }: DesktopFiltersProps) {
  const { isFiltersSet, clearFilters } = useFilters()

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          type="button"
          variant="secondary"
          icon={FilterIcon}
          className="relative"
        >
          {isFiltersSet() && (
            <span className="size-2.5 rounded-full bg-indigo-400 absolute top-0 right-0" />
          )}
        </Button>
      </PopoverTrigger>

      <PopoverContent
        sideOffset={4}
        collisionPadding={16}
        className="text-sm w-full min-w-[12rem] py-1.5 border border-gray-100 z-50 rounded-xl bg-white shadow-xl"
        asChild
      >
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.1 }}
        >
          {filters.map((opt, key) => (
            <FilterItem
              key={key}
              filter={opt}
            />
          ))}

          {isFiltersSet() && (
            <Fragment>
              <div className="my-1.5">
                <Divider />
              </div>

              <button
                className="w-full px-3 py-2 focus:outline-none hover:bg-gray-50/50 cursor-pointer text-left"
                onClick={clearFilters}
              >
                <Text type="s">
                  Clear filters
                </Text>
              </button>
            </Fragment>
          )}
        </motion.div>
      </PopoverContent>
    </Popover>
  )
}
